<template>
  <div class="field has-addons">
    <div class="control">
      <div class="select">
        <select @input="updateTime('h', $event.target.value)" :value="hTwelve">
          <option v-for="(t, i) in 12" :key="i" :value="t">{{(t > 9) ? t : '0' + t}}</option>
        </select>
      </div>
    </div>
    <div class="control">
      <a class="button is-static">
        :
      </a>
    </div>
    <div class="control">
      <div class="select">
        <select @input="updateTime('m', $event.target.value)" :value="mClosestFive">
          <option :value="0">00</option>
          <option v-for="(t, i) in 11" :key="i" :value="t*5">{{(t*5 > 9) ? t*5 : '0' + t*5}}</option>
        </select>
      </div>
    </div>
    <div class="control">
      <div class="select">
        <select @input="updateTime('ampm', $event.target.value)" :value="aMpM">
          <option value="am">AM</option>
          <option value="pm">PM</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    'value': {
      type: String,
      default () {
        return moment().toISOString()
      }
    }
  },
  data () {
    return {
      d: ''
    }
  },
  mounted () {
    this.setDateTime()
  },
  methods: {
    setDateTime () {
      this.d = moment(this.value).toISOString()
    },
    updateInput (value) {
      this.$emit('input', value)
    },
    updateTime (what, value) {
      let m = moment(this.d)

      if (what === 'h') {
        value = parseInt(value)
        m.set('hour', (this.aMpM === 'pm') ? value + 12 : value)
      } else if (what === 'm') {
        value = parseInt(value)
        m.set('minute', value)
      } else {
        if (value === 'am') {
          m.set('hour', this.h - 12)
        } else {
          m.set('hour', this.h + 12)
        }
      }

      this.d = m.toISOString()
    }
  },
  computed: {
    h () {
      return moment(this.d).get('hour')
    },
    hTwelve () {
      return (this.h === 0) ? 12 : (this.h > 12) ? this.h - 12 : this.h
    },
    m () {
      return moment(this.d).get('minute')
    },
    mClosestFive () {
      return Math.ceil(this.m / 5) * 5
    },
    aMpM () {
      return (this.h < 12) ? 'am' : 'pm'
    }
  },
  watch: {
    d (newVal) {
      if (newVal) {
        this.updateInput(newVal)
      }
    },
    value (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setDateTime()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/inputTime.vue